export default __webpack_public_path__ + "static/media/WhiteBgBanner.2f6db1f6.svg";